import React from 'react'
import * as R from 'ramda'
import Buttons from 'sidecar-ui/lib/Buttons'
import ContinueButton from 'sidecar-ui/lib/Button/ContinueButton'
import { ModalBody } from 'sidecar-ui/lib/Modal'

import { Modal } from './styles'

const ConfirmModal = ({ isOpen, onClose = R.identity }) => (
  <Modal isOpen={isOpen} title="Are you still there?">
    <ModalBody>
      <p>
        For security, we will be logging you out in 1 minute unless you continue
        your session.
      </p>
      <Buttons>
        <ContinueButton onClick={onClose} label="I'm still here" full />
      </Buttons>
    </ModalBody>
  </Modal>
)

export default ConfirmModal



// WEBPACK FOOTER //
// ./src/modals/AutoLogoutModal/index.js